// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductAutocompleteItemModel } from "@insite/client-framework/Types/ApiModels";
import { OptionObject } from "@insite/mobius/DynamicDropdown";
import ProductSearchDropdownOption from "@vanmeter/App/Components/Product/ProductSearchDropdownOption";
import React from "react";

// XNG-Changes: shared mapping for my account product search dropdowns
export const mapSearchResultsToDropdownOptions = (
    searchResults: ProductAutocompleteItemModel[],
    testSelectorPrefix?: string,
): OptionObject[] => {
    return searchResults.map(product => ({
        optionText: product.erpNumber,
        optionValue: product.id || undefined,
        rowChildren: (
            <ProductSearchDropdownOption
                product={product}
                dataTestSelector={testSelectorPrefix ? `${testSelectorPrefix}_${product.id}` : undefined}
            />
        ),
    }));
};
